import { motion } from "framer-motion";
import { MapPin, Clock, Phone } from "lucide-react";

export const LocationSection = () => {
  return (
    <section
      id="localizacao"
      data-testid="location-section"
      className="py-28 md:py-40 bg-white overflow-x-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <p className="font-body text-gold text-xs font-medium tracking-[0.35em] uppercase mb-4">
            Localização
          </p>
          <h2 className="font-heading text-navy text-4xl md:text-5xl font-medium leading-tight">
            Moriá Saúde
          </h2>
          <div className="gold-line mt-6" />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* Info cards */}
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-2 space-y-4"
          >
            <div className="bg-[#F3F3F3] p-7" data-testid="location-address">
              <MapPin className="text-gold/70 mb-4" size={22} />
              <h3 className="font-heading text-navy text-lg font-medium mb-2">
                Endereço
              </h3>
              <p className="font-body text-navy/60 text-sm leading-relaxed">
                Av. Adolfo Fetter, 3419 - 5 — Laranjal
                <br />
                Pelotas — RS, 96090-840
              </p>
              <p className="font-body text-navy/45 text-xs mt-3 leading-relaxed">
                Consultas e atendimentos na Moriá Saúde. Cirurgias realizadas em ambiente hospitalar.
              </p>
            </div>

            <div className="bg-[#F3F3F3] p-7" data-testid="location-hours">
              <Clock className="text-gold/70 mb-4" size={22} />
              <h3 className="font-heading text-navy text-lg font-medium mb-2">
                Horário
              </h3>
              <div className="font-body text-navy/55 text-sm leading-relaxed space-y-1">
                <p>Segunda a Sexta: 9h — 19h</p>
                <p>Sábado: 9h — 12h</p>
                <p className="text-navy/35">Domingo: Fechado</p>
              </div>
            </div>

            <div className="bg-[#F3F3F3] p-7" data-testid="location-phone">
              <Phone className="text-gold/70 mb-4" size={22} />
              <h3 className="font-heading text-navy text-lg font-medium mb-2">
                Telefone
              </h3>
              <a
                href="tel:+5551997410236"
                className="font-body text-navy/55 text-sm hover:text-gold transition-colors duration-300"
              >
                (51) 99741-0236
              </a>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, x: 24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-3"
          >
            <div className="w-full h-full min-h-[420px] overflow-hidden" data-testid="location-map">
              <iframe
                title="Moriá Saúde — Pelotas"
                src="https://maps.google.com/maps?q=Mori%C3%A1+Sa%C3%BAde+Av.+Adolfo+Fetter+3419+Laranjal+Pelotas+RS+96090-840&t=&z=16&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, minHeight: "420px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
